import React, { Component } from 'react';
import InputCurrency from '../input-currency';
import RentCalc from '../inputRentCalculator/rentCalc';
import i18n from 'app/common/i18n';

class InputRentCalc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      factor: null
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.rentValue !== nextProps.rentValue) {
      if (this.state.factor !== null) {
        this.props.onChange({
          target: {
            name: this.props.name,
            value: nextProps.rentValue * this.state.factor,
            type: 'mixed'
          }
        });
      }
    }
  }

  handleChange(ev) {
    const { name } = ev.target;
    if (name === this.props.name) {
      this.setState({ factor: null });
    }
    this.props.onChange(ev);
  }

  handleClick(factor) {
    this.setState({ factor });
    if (Boolean(this.props.rentValue) !== false) {
      const calculatedValue = this.props.rentValue * factor;
      this.props.onChange({
        target: {
          name: this.props.name,
          value: calculatedValue,
          type: 'mixed'
        }
      });
    }
  }

  render() {
    const { rentValue, error, ...rest } = this.props;

    return (
      <InputCurrency
        error={error}
        helperText={
          <>
            <RentCalc onClick={this.handleClick} />
            <br />
            {this.props.defaultValue > 3 * rentValue && (
              <span
                style={{
                  color: 'rgb(255, 152, 0)',
                  display: 'inline-block',
                  paddingTop: '0.5em'
                }}
              >
                {this.props.i18n('Maksimalt 3 x huslejen eksklusiv forbrug')}
              </span>
            )}
            {error}
          </>
        }
        {...rest}
        onChange={this.handleChange}
      />
    );
  }
}

export default i18n(InputRentCalc);
